import { useState } from 'react';

import { ShippingPendingContext } from './_context';

import ShippingPendingComponent from './ShippingPendingComponent';

const ShippingPendingContainer = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [dropdownOptionsChannels, setDropdownOptionsChannels] = useState('');
  const [selectChannel, setSelectChannel] = useState('');

  const shippingValues = {
    modalOpen,
    setModalOpen,
    dropdownOptionsChannels,
    setDropdownOptionsChannels,
    selectChannel,
    setSelectChannel,
  };

  return (
    <ShippingPendingContext.Provider value={shippingValues}>
      <ShippingPendingComponent />
    </ShippingPendingContext.Provider>
  );
};

export default ShippingPendingContainer;
